export default __webpack_public_path__ + "static/media/18.ae056a69.mp3";